'use client';
import React, { useMemo } from 'react';
import MapTopNavbar from './TopNavbar';
import MobileSidebarContainer from '../sidebar/MobileSidebarContainer';
import DesktopSidebarContainer from '../sidebar/DesktopSidebarContainer';
import { ReactFlowProvider } from '@xyflow/react';
import LayoutFlowContainer from '../graph/LayoutFlowContainer';



function Nav({ children, user, activeMap }: any) {
    const [showLoadingContent, setShowLoadingContent] = React.useState(false);

      const DesktopFlow = useMemo(() => {
        return (
          <ReactFlowProvider>
            <LayoutFlowContainer graphID={'desktop-sidebar-graph'} />
          </ReactFlowProvider>
        );
      }, []);

      const MobileFlow = useMemo(() => {
        return (
          <ReactFlowProvider>
            <LayoutFlowContainer graphID={'mobile-sidebar-graph'} />
          </ReactFlowProvider>
        );
      }, []); 
  return (
    <div className="h-[100vh] flex flex-col">
      <MapTopNavbar user={user} activeMap={activeMap} />
      <MobileSidebarContainer user={user} setShowLoadingContent={setShowLoadingContent} graphID={'mobile-nav-graph'}>
        {MobileFlow}
      </MobileSidebarContainer>
      <DesktopSidebarContainer
        user={user}
        setShowLoadingContent={setShowLoadingContent}
        showLoadingContent={showLoadingContent}
        graphID={'desktop-nav-graph'}
        flow={DesktopFlow}
      >
        {children}
      </DesktopSidebarContainer>
    </div>
  );
}

export default Nav;
